import React, {useContext} from "react";
import OwTitle from "../OwTitle/OwTitle";
import UiContext from "../../../contexts/UiContext";

type Props = {
    uiVersion: string;
};


const UIVersionRefresh = (props: Props) => {
    const uiContext = useContext(UiContext);

    let width = '100%';

    if (uiContext.menuOpen) {
        width = (document.getElementById('mainView')?.offsetWidth + "px") || "100%";
    }

    return (
        <div
            className={( uiContext.menuOpen? "" : "w-100") + " UIVersionRefresh position-absolute faded-orange-bg black-color p-1 text-center pointer"}
            style={{ zIndex: 100, width }}
            onClick={() => {
                window.location.reload();
            }}>
            <OwTitle className={"d-inline-flex me-2"} title={"new_version_click_to_refresh"} tag={"h6"} />
            <h6 className={"d-inline-flex"}>v{props.uiVersion}</h6>
        </div>
    );
}

export default UIVersionRefresh;
